'use client';
import React from 'react';

const categories = [
  {
    emoji: '🍔',
    name: 'Food',
    color: '#f97316',
    bg: 'linear-gradient(135deg, #2a1500 0%, #1a0d00 100%)',
    border: '#3d2000',
  },
  {
    emoji: '🛒',
    name: 'Grocery',
    color: '#22c55e',
    bg: 'linear-gradient(135deg, #0a1f0a 0%, #051005 100%)',
    border: '#1a3a1a',
  },
  {
    emoji: '💊',
    name: 'Pharmacy',
    color: '#38bdf8',
    bg: 'linear-gradient(135deg, #0a0f1f 0%, #050810 100%)',
    border: '#1a2040',
  },
  {
    emoji: '📦',
    name: 'Parcels',
    color: '#a78bfa',
    bg: 'linear-gradient(135deg, #1a0f2a 0%, #0d0818 100%)',
    border: '#2d1a4a',
  },
  {
    emoji: '👗',
    name: 'Fashion',
    color: '#f472b6',
    bg: 'linear-gradient(135deg, #1f0a1a 0%, #10050e 100%)',
    border: '#3a1030',
  },
  {
    emoji: '🔧',
    name: 'Services',
    color: '#2dd4bf',
    bg: 'linear-gradient(135deg, #0a1a1a 0%, #050e0e 100%)',
    border: '#1a3030',
  },
];

export default function WhatWeDeliver() {
  return (
    <section id="features" className="py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Section Label */}
        <div className="mb-6">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest bg-[#1a0e00] border border-[#3d2000] text-[#f97316]">
            WHAT WE DELIVER
          </span>
        </div>

        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-10 leading-tight">
          Everything you need,
          <br />
          right to your door.
        </h2>

        {/* Category Grid */}
        <div className="grid grid-cols-3 gap-3 md:gap-4">
          {categories?.map((cat, i) => (
            <div
              key={i}
              className="rounded-2xl flex flex-col items-center justify-center cursor-pointer hover:opacity-90 transition-all duration-200 hover:scale-[1.02] aspect-square"
              style={{
                background: cat?.bg,
                border: `1px solid ${cat?.border}`,
                minHeight: '180px',
              }}
            >
              <span className="text-4xl md:text-5xl mb-3">{cat?.emoji}</span>
              <span className="text-sm font-semibold" style={{ color: cat?.color }}>
                {cat?.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
